// AUTHENTICATION
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const AUTH_CHECK = 'check';
export const AUTH_REFRESH = 'refresh';
export const AUTH_REFETCH = 'refetch';

export const SEARCH = 'search';
export const FETCH = 'fetch';
export const FETCH_ALL = 'fetchAll';
export const REMOVE = 'remove';
export const SAVE = 'save';
